const PRICECHARTING_ORIGIN = "https://www.pricecharting.com";

const priceChartingSlug = (value: string) =>
  value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[’']/g, "")
    .replace(/[^a-z0-9&]+/g, "-")
    .replace(/^-+|-+$/g, "");

export function priceChartingProductUrl(
  system: string | null | undefined,
  name: string | null | undefined,
  setName: string | null | undefined,
): string | null {
  if (system !== "pricecharting" || !name || !setName) return null;
  const setSlug = encodeURIComponent(priceChartingSlug(setName));
  const productSlug = encodeURIComponent(priceChartingSlug(name));
  return `${PRICECHARTING_ORIGIN}/game/${setSlug}/${productSlug}`;
}

/**
 * Returns the attribution line under a PriceCharting Market value.
 *
 * `combined` is the server's disclosure (`GradedPriceOut.combined` or `CardScopeOut`'s
 * `market_combined`), decided by the adapter that read the provider field. Do not re-derive it
 * from the grade: a second copy of PriceCharting's exact-vs-combined ladder would drift when the
 * provider changes which grades are combined. This function only names the combined bucket.
 */

export function priceChartingMarketLabel(
  grade: string | null | undefined,
  combined: boolean | null | undefined,
): string {
  if (!combined || !grade) return "Market data by PriceCharting";
  const bucket = priceChartingGradeBucket(grade);
  const noun = bucket.includes("/") ? "Grades" : "Grade";
  return `PriceCharting ${noun} ${bucket} market · graders combined`;
}

/**
 * Names the grades a combined figure answers for: "7/7.5", "8/8.5", or the grade itself.
 *
 * ADR-0091 requires a combined value to name its half-grade range, because the provider quotes 7
 * and 7.5 off one field and 8 and 8.5 off another. Only ever applied to a value the server already
 * disclosed as combined; it names a bucket and never decides whether there is one.
 */
export function priceChartingGradeBucket(grade: string): string {
  if (grade === "7" || grade === "7.5") return "7/7.5";
  return grade === "8" || grade === "8.5" ? "8/8.5" : grade;
}
